// extracted by mini-css-extract-plugin
export default {"mainWrapper":"documents_mainWrapper__jv+X9","taskChipWrapper":"documents_taskChipWrapper__iNp87"};